import React, {createContext, useState} from "react";

export const PaymentLinkContext = createContext();

export const PaymentLinkProvider = ({ children }) => {
    const [constantPaymentLinks, setConstantPaymentLinks] =useState([]);
    const [paymentLinks, setPaymentLinks] =useState([]);
    const [contactList, setContactList] =useState([]);

    return (
        <PaymentLinkContext.Provider value={{ paymentLinks, setPaymentLinks, contactList, setContactList, constantPaymentLinks, setConstantPaymentLinks}}>
            {children}
        </PaymentLinkContext.Provider>
    )
}